import { render, staticRenderFns } from "./EducationalGroupAttendanceTable.vue?vue&type=template&id=5df5161a&"
import script from "./EducationalGroupAttendanceTable.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupAttendanceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports